const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images',
  IDB_NAME: 'botram-restaurant',
  IDB_VERSION: 1,
  OBJECT_STRORE_NAME: 'favorite-restaurant',
  CACHE_NAME: `BotramFindRestaurant-${new Date().toDateString()}`,
};

export default CONFIG;
